var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: { width: "720", title: "选择文章" },
          on: { "on-ok": _vm.cursorSelect },
          model: {
            value: _vm.showSelectAuction,
            callback: function ($$v) {
              _vm.showSelectAuction = $$v
            },
            expression: "showSelectAuction",
          },
        },
        [
          _c(
            "div",
            { staticClass: "search" },
            [
              _c("Input", {
                staticClass: "w200",
                attrs: { placeholder: "文章名称搜索" },
                on: { "on-enter": _vm.searchWorkAction },
                model: {
                  value: _vm.workName,
                  callback: function ($$v) {
                    _vm.workName = $$v
                  },
                  expression: "workName",
                },
              }),
              _vm._v(" "),
              _c(
                "Select",
                {
                  staticClass: "w200 ml10",
                  attrs: { filterable: "", placeholder: "文章专辑搜索" },
                  model: {
                    value: _vm.categoryName,
                    callback: function ($$v) {
                      _vm.categoryName = $$v
                    },
                    expression: "categoryName",
                  },
                },
                [
                  _c("Option", { attrs: { value: "" } }, [_vm._v("全部")]),
                  _vm._v(" "),
                  _vm._l(_vm.categoryArticleList, function (item) {
                    return _c(
                      "Option",
                      { key: item.id, attrs: { value: item.id } },
                      [_vm._v(_vm._s(item.name))]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "Select",
                {
                  staticClass: "w200 ml10",
                  attrs: {
                    filterable: "",
                    placeholder: "发布者",
                    remote: "",
                    "remote-method": _vm.searchPost,
                    loading: _vm.searchLoading,
                  },
                  model: {
                    value: _vm.announcer,
                    callback: function ($$v) {
                      _vm.announcer = $$v
                    },
                    expression: "announcer",
                  },
                },
                [
                  _c("Option", { attrs: { value: "0" } }, [_vm._v("全部")]),
                  _vm._v(" "),
                  _vm._l(_vm.announcerList, function (item) {
                    return _c(
                      "Option",
                      { key: item.uid, attrs: { value: item.uid } },
                      [_vm._v(_vm._s(item.uname))]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Button",
            {
              staticClass: "mt10",
              attrs: { type: "primary" },
              nativeOn: {
                click: function ($event) {
                  return _vm.searchWorkAction($event)
                },
              },
            },
            [_vm._v("筛选")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "h400 mt20",
              staticStyle: { "border-top": "1px solid #eee" },
            },
            [
              _c(
                "table",
                { staticClass: "spec-table" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("td", { attrs: { width: "40%", align: "center" } }, [
                        _vm._v("作品信息"),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "20%", align: "center" } }, [
                        _vm._v("发布者"),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "25%", align: "center" } }, [
                        _vm._v("发布时间"),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "15%", align: "center" } }, [
                        _vm._v("操作"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.resultData, function (m, i) {
                    return _c("tbody", { key: i, staticClass: "list" }, [
                      _c("tr", { staticClass: "border-t" }, [
                        _c("td", { staticClass: "bgWhite" }, [
                          _c(
                            "div",
                            { staticClass: "display-flex item-align-center" },
                            [
                              m.photo
                                ? _c("img", {
                                    staticStyle: {
                                      width: "90px",
                                      height: "90px",
                                      display: "block",
                                      "flex-shrink": "0",
                                    },
                                    attrs: { src: m.photo + "!120a" },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "ml10" }, [
                                _c("p", [_vm._v("作品标识：" + _vm._s(m.id))]),
                                _vm._v(" "),
                                _c("p", { staticClass: "mt5" }, [
                                  _vm._v(_vm._s(m.title)),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "bgWhite",
                            attrs: { align: "center" },
                          },
                          [_c("div", [_vm._v(_vm._s(m.artiest_name))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "bgWhite",
                            attrs: { align: "center" },
                          },
                          [_c("div", [_vm._v(_vm._s(m.create_time))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "bgWhite",
                            attrs: { align: "center" },
                          },
                          [
                            _vm.selectedAuctionIdList.indexOf(m.id) == -1
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { color: "#28ab29" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.auctionSelectedAction(
                                            $event,
                                            i
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("选择")]
                                  ),
                                ])
                              : _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { color: "#28ab29" },
                                      on: {
                                        click: function ($event) {
                                          _vm.auctionCancelAction(
                                            $event,
                                            _vm.selectedAuctionIdList.indexOf(
                                              m.id
                                            )
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("取消选择")]
                                  ),
                                ]),
                          ]
                        ),
                      ]),
                    ])
                  }),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt20" },
            [
              _c("Page", {
                staticStyle: { "text-align": "right" },
                attrs: {
                  total: _vm.total,
                  "page-size": _vm.queryParams.size,
                  "show-sizer": "",
                  "show-total": "",
                  "show-elevator": "",
                  current: _vm.queryParams.page,
                },
                on: {
                  "on-page-size-change": _vm.changePageSize,
                  "on-change": _vm.changePage,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }